import { render, staticRenderFns } from "./ParentDetails.vue?vue&type=template&id=790cd185&"
import script from "./ParentDetails.vue?vue&type=script&lang=js&"
export * from "./ParentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports